









import Vue from 'vue';
import moment from 'moment';
import SavingStatus from './SavingStatus.vue';

interface Data {
  task: Promise<any>|null,
  isSaving: boolean,
  lastSave: string|null,
  error: string|null,
}

export default Vue.extend({
  components: { SavingStatus },
  props: {
    tasks: {
      type: Array as () => Promise<any>[],
      default: () => [],
    },
    lastSaveText: {
      type: String,
      default: 'Saved',
    },
  },
  data(): Data {
    return {
      task: null,
      isSaving: false,
      lastSave: null,
      error: null,
    };
  },
  watch: {
    tasks(tasks: Promise<any>[]) {
      if (!tasks.length) return;
      tasks.forEach((task: Promise<any>) => {
        task
          .then(() => {
            this.lastSave = moment().toISOString();
            this.$emit('saved', this.lastSave);
          })
          .catch((error: Error) => {
            this.error = error.message;
            this.$emit('error', this.error);
          });
      });

      this.task = this.finishSaving().finally(() => {
        this.isSaving = true;
        return Promise.all(tasks).finally(() => {
          this.isSaving = false;
        });
      });
      this.$emit('update:tasks', []);
    },
  },
  methods: {
    finishSaving(): Promise<any> {
      if (this.task) return this.task;
      return Promise.resolve();
    },
  },
});
